import { CARD_COUNT } from "./config";

export const clamp = (v, min, max) => Math.min(max, Math.max(min, v));
export const lerp = (a, b, t) => a + (b - a) * t;
export const map = (v, a, b, c, d) => c + ((v - a) / (b - a)) * (d - c);

export function damp(current, target, lambda, dt) {
  return lerp(current, target, 1 - Math.exp(-lambda * dt));
}

export function ringAngle(index, count = CARD_COUNT) {
  return ((index - count * 0.75) * Math.PI * 2) / count;
}
